export default __webpack_public_path__ + "static/media/431.54bdb8ae.gif";